
const nextPages = [
  /^\/inspiration\/blog\/.*/
];

/**
 * Whether the url matches a page we've migrated to the new NextJS project.
 * @deprecated We're migrating pages to Next, don't use this method otherwise.
 */
export const shouldServePageFromNext = (href: string) => nextPages.some(regex => regex.test(href));
